import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="chart-buttons"
export default class extends Controller {
  static targets = ["button"];

  selectRange(event) {
    // Update active button state
    this.buttonTargets.forEach((btn) => {
      btn.classList.remove("btn-dark");
      btn.classList.add("btn-outline-dark");
    });

    event.currentTarget.classList.remove("btn-outline-dark");
    event.currentTarget.classList.add("btn-dark");
  }
}
